module.exports = __webpack_public_path__ + "static/media/photography-of-city-buildings-941195@3x.01a44f26.png";